/**
 * StopWatching – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** Stop watching / remove from list indicator. */
export default function StopWatchingIcon({ focused, height, width }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height={`${height || 32 * Screen.widthRatio}`}
      width={`${width || 40 * Screen.widthRatio}`}
      viewBox={'0 0 62 50'}
    >
      <path
        d='M30.8357 32.5339C35.3767 32.5339 39.0579 28.8527 39.0579 24.3118C39.0579 19.7708 35.3767 16.0896 30.8357 16.0896C26.2947 16.0896 22.6135 19.7708 22.6135 24.3118C22.6135 28.8527 26.2947 32.5339 30.8357 32.5339Z'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
      <path
        d='M61.0059 22.0764C57.6066 16.8193 53.1962 12.3536 48.2526 9.16113C42.7836 5.62559 36.7454 3.75633 30.792 3.75633C25.3294 3.75633 19.958 5.31726 14.8269 8.39544C9.59424 11.534 4.85364 16.1191 0.736134 22.0224C0.271305 22.6896 0.0153052 23.4798 0.00066501 24.2928C-0.0139752 25.1058 0.213405 25.9048 0.653912 26.5883C4.04684 31.898 8.41359 36.3701 13.2801 39.5189C18.7594 43.0686 24.6562 44.8672 30.792 44.8672C36.7929 44.8672 42.8439 43.0133 48.2898 39.5074C53.2309 36.3251 57.6323 31.8428 61.0188 26.542C61.4441 25.8744 61.669 25.0989 61.6667 24.3073C61.6644 23.5158 61.4351 22.7415 61.0059 22.0764ZM30.8357 36.645C28.3964 36.645 26.0119 35.9217 23.9837 34.5665C21.9555 33.2113 20.3747 31.2851 19.4413 29.0315C18.5078 26.7779 18.2635 24.2981 18.7394 21.9057C19.2153 19.5132 20.3899 17.3157 22.1148 15.5908C23.8396 13.866 26.0372 12.6914 28.4296 12.2155C30.822 11.7396 33.3018 11.9838 35.5554 12.9173C37.8091 13.8508 39.7352 15.4316 41.0904 17.4598C42.4456 19.488 43.169 21.8725 43.169 24.3118C43.1652 27.5816 41.8646 30.7164 39.5525 33.0286C37.2404 35.3407 34.1055 36.6413 30.8357 36.645Z'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
      <path
        d='M7.49968 48.2558C6.53639 47.2925 6.53639 45.7307 7.49968 44.7674L50.5229 1.74419C51.4862 0.780897 53.048 0.780899 54.0113 1.74419C54.9746 2.70747 54.9746 4.26927 54.0113 5.23256L10.9881 48.2558C10.0248 49.2191 8.46297 49.2191 7.49968 48.2558Z'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
    </svg>
  );
}
